/* @flow */
import React, { Component } from 'react';
import { css, names } from 'linaria';

import AppStoreBadges from '../AppStoreBadges';
import Colors from '../../constants/Colors';
import { Container, Grid, GridCell, Icon, Spacer, Link, Text, Title } from '../core';
import Links from '../../../data/Links';
import MediaQueries from '../../constants/MediaQueries';
import Responsive from '../../constants/Responsive';

const COI = require('../../../assets/coi.pdf');

function LinkList({
  title,
  titleColor,
  children,
}: {
  title: string,
  titleColor: string,
  children?: any,
}) {
  return (
    <GridCell size={Responsive('size6of12', 'size3of12')}>
      <Title size="22" weight="bold" color={titleColor}>
        {title}
      </Title>
      <ul className={Styles.NavList}>
        {React.Children.map(children, (child, i) => {
          return (
            <li key={`nav-item-${i}`} className={Styles.NavListItem}>
              {child}
            </li>
          );
        })}
      </ul>
    </GridCell>
  );
}

class SiteFooter extends Component<{
  theme: 'light' | 'dark' | 'dark-blue',
}> {
  render() {
    let { theme } = this.props;

    return (
      <footer className={Styles.Container}>
        <Container className={Styles.Navigation}>
          <Grid hAlign="center">
            <LinkList title="Lugg" titleColor={ThemeStyles[theme].TitleColor}>
              <Link
                className={names(Styles.NavListLink, ThemeStyles[theme].NavListLink)}
                to="/account/luggs">
                My Account
              </Link>
              <Link
                className={names(Styles.NavListLink, ThemeStyles[theme].NavListLink)}
                to="/services">
                Services
              </Link>
              <Link
                className={names(Styles.NavListLink, ThemeStyles[theme].NavListLink)}
                to="/cities">
                Cities
              </Link>
              <Link
                className={names(Styles.NavListLink, ThemeStyles[theme].NavListLink)}
                to="/estimate">
                Get an estimate
              </Link>
              <Link
                className={names(Styles.NavListLink, ThemeStyles[theme].NavListLink)}
                to="/partner">
                Become a partner
              </Link>
            </LinkList>
            <LinkList title="Luggers" titleColor={ThemeStyles[theme].TitleColor}>
              <Link
                className={names(Styles.NavListLink, ThemeStyles[theme].NavListLink)}
                to="/become-a-lugger">
                Become a lugger
              </Link>
            </LinkList>
            <LinkList title="Questions?" titleColor={ThemeStyles[theme].TitleColor}>
              <Link className={names(Styles.NavListLink, ThemeStyles[theme].NavListLink)} to="/faq">
                Frequently asked questions
              </Link>
              <Link
                className={names(Styles.NavListLink, ThemeStyles[theme].NavListLink)}
                to="/contact">
                Contact us
              </Link>
              <Link
                className={names(Styles.NavListLink, ThemeStyles[theme].NavListLink)}
                to="/safety">
                Safety
              </Link>
              <Link
                className={names(Styles.NavListLink, ThemeStyles[theme].NavListLink)}
                to={COI}
                target="_blank">
                Insurance Certificate
              </Link>
            </LinkList>
            <LinkList title="About" titleColor={ThemeStyles[theme].TitleColor}>
              <a
                className={names(Styles.NavListLink, ThemeStyles[theme].NavListLink)}
                href={Links.Blog}>
                Blog
              </a>
              <a
                className={names(Styles.NavListLink, ThemeStyles[theme].NavListLink)}
                href={Links.Jobs}>
                Careers
              </a>
            </LinkList>
          </Grid>
          <div className={Styles.BadgeBar}>
            <AppStoreBadges />
          </div>
        </Container>
        <Spacer color={ThemeStyles[theme].DividerColor} />
        <Container className={Styles.Legal}>
          <Grid>
            <GridCell size={Responsive('sizeFull', 'size6of12')} className={Styles.BottomLeft}>
              <ul className={names(Styles.InlineList, Styles.SocialList)}>
                <li className={Styles.SocialItem}>
                  <a href={Links.Twitter}>
                    <Icon name="twitter" />
                  </a>
                </li>
                <li className={Styles.SocialItem}>
                  <a href={Links.Instagram}>
                    <Icon name={ThemeStyles[theme].InstagramIcon} />
                  </a>
                </li>
                <li className={Styles.SocialItem}>
                  <a href={Links.Facebook}>
                    <Icon name="facebook" />
                  </a>
                </li>
                <li className={Styles.SocialItem}>
                  <a href={Links.Tiktok}>
                    <Icon name="tiktok" />
                  </a>
                </li>
                <li className={Styles.SocialItem}>
                  <a href={Links.Youtube}>
                    <Icon name="youtube" />
                  </a>
                </li>
              </ul>
            </GridCell>
            <GridCell size={Responsive('sizeFull', 'size6of12')} className={Styles.BottomRight}>
              <ul className={names(Styles.InlineList)}>
                <li>
                  <Link to="/privacy">
                    <Text size="14">Privacy Policy</Text>
                  </Link>
                </li>
                <li style={{ marginLeft: 20 }}>
                  <Link to="/terms">
                    <Text size="14">Terms of Service</Text>
                  </Link>
                </li>
                <li style={{ marginLeft: 20 }}>
                  <Text size="14">{`\u00A9 ${new Date().getFullYear()} Lugg`}</Text>
                </li>
              </ul>
            </GridCell>
          </Grid>
        </Container>
      </footer>
    );
  }
}

const ThemeStyles = {
  light: {
    InstagramIcon: 'instagram',
    DividerColor: Colors.opacity(Colors.IndigoDark, 0.05),
    TitleColor: Colors.Black,
    NavListLink: css`
      color: ${Colors.Indigo};
    `,
  },
  dark: {
    InstagramIcon: 'instagram-white',
    DividerColor: Colors.opacity(Colors.White, 0.1),
    TitleColor: '#606271',
    NavListLink: css`
      color: ${Colors.White};
    `,
  },
  'dark-blue': {
    InstagramIcon: 'instagram-white',
    DividerColor: Colors.opacity(Colors.White, 0.1),
    TitleColor: Colors.White,
    NavListLink: css`
      color: #9ea1ae;
    `,
  },
};

const Styles = {
  Container: css`
    padding-top: 62px;
  `,
  Estimate: css`
    margin-bottom: 75px;
  `,
  Navigation: css`
    padding-bottom: 40px;
  `,
  Legal: css`
    padding: 24px 0;
  `,
  NavList: css`
    margin-top: 8px;
    padding-right: 16px;
    margin-bottom: 34px;
    ${MediaQueries.Medium} {
      margin-bottom: 0;
    }
  `,
  NavListItem: css`
    padding: 4px 0;
  `,
  NavListLink: css`
    font-size: 16px;
  `,
  BadgeBar: css`
    display: flex;
    justify-content: center;
  `,
  BottomLeft: css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 26px;
    ${MediaQueries.Medium} {
      justify-content: flex-start;
      margin-bottom: 0;
    }
  `,
  BottomRight: css`
    display: flex;
    justify-content: center;
    ${MediaQueries.Medium} {
      justify-content: flex-end;
    }
  `,
  InlineList: css`
    display: flex;
    align-items: center;
  `,
  SocialList: css`
    margin-left: 24px;
  `,
  SocialItem: css`
    margin-right: 22px;
  `,
};

export default SiteFooter;



// WEBPACK FOOTER //
// ./src/ui/components/chrome/SiteFooter.js